import Typography from '@material-ui/core/Typography';
import styled from "styled-components"

export const MainTitle = styled(Typography).attrs({
    variant:'h3',
})`
    margin:${props => props.theme.spacing(2)}px;
    font-weight:700;
    text-align:left;
    width:90%;
    font-size: 2.2rem;
    @media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){
      width:100%;
      margin:${props => props.theme.spacing(2)}px 0;
      text-align:${props => props.align ? props.align : "left"};
    }
`

export const SectionTitle = styled(Typography).attrs({
  variant:'h4',
})`
  margin-top:${props => props.theme.spacing(2)}px;
  font-weight:700;
  
`

export const SubTitle = styled(Typography).attrs({
  variant:'subtitle1',
})`
  margin-bottom:${props => props.theme.spacing(4)}px;
  font-weight:400;
`

export const BodyTitle = styled(Typography).attrs({
  variant:'h6',
})`
  margin:${props => props.theme.spacing(2)}px 0;
  font-weight:700;
  text-align:${props => props.align ? props.align : "left"};
  width:100%;
`

export const BodyText = styled(Typography).attrs({
  variant:'body1',
})`
  margin:${props => props.theme.spacing(1)}px auto;
  font-weight:400;
  text-align:${props => props.align ? props.align : "left"};
  width:90%;
    @media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){
      width:100%;
    }
`

export const CopyText = styled(Typography).attrs({
  variant:'caption',
})`
  margin:${props => props.theme.spacing(1)}px auto;
  font-weight:400;
  color:white;
  text-align:${props => props.align ? props.align : "left"};
  width:90%;
    @media screen and (min-width: ${props => props.theme.breakpoints.values.sm}px){
      width:100%;
    }
`
